/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
author: Caboose3d (https://sketchfab.com/caboosereynolds)
license: CC-BY-4.0 (http://creativecommons.org/licenses/by/4.0/)
source: https://sketchfab.com/3d-models/country-side-fence-8585e102c6104a6d90e823de83e73bbc
title: Country Side Fence
*/

import React, { Suspense, useRef } from 'react'
import { useGLTF } from '@react-three/drei/useGLTF'
import { useBox } from 'use-cannon'

export function Fence01(props) {
  const visibleHitBox = useRef(false)

  const [ref] = useBox(() => ({
    mass: 0,
    args: [12, 10, 1],
    ...props,
  }))

  const { nodes, materials } = useGLTF(
    '/three-fps/models/objects/fence01/scene.gltf'
  )
  return (
    <mesh ref={ref} scale={props.scale} dispose={null}>
      {visibleHitBox.current ? (
        <>
          <boxBufferGeometry
            attach="geometry"
            args={[
              12 / props.scale[0],
              10 / props.scale[1],
              1 / props.scale[2],
            ]}
          />
          <meshLambertMaterial color="red" opacity={0.7} transparent />
        </>
      ) : null}
      <Suspense fallback={null}>
        <group rotation={[-Math.PI / 2, 0, 0]}>
          <group rotation={[Math.PI / 2, 0, 0]}>
            <mesh
              material={materials.lambert1}
              geometry={nodes.pCylinder10_lambert1_0.geometry}
            />
            <mesh
              material={materials.lambert1}
              geometry={nodes.pCylinder11_lambert1_0.geometry}
            />
            <mesh
              material={materials.lambert1}
              geometry={nodes.pCylinder6_lambert1_0.geometry}
            />
            <mesh
              material={materials.lambert1}
              geometry={nodes.pCylinder15_lambert1_0.geometry}
            />
            <mesh
              material={materials.lambert1}
              geometry={nodes.pCylinder12_lambert1_0.geometry}
            />
            <mesh
              material={materials.lambert1}
              geometry={nodes.pCylinder13_lambert1_0.geometry}
            />
            <mesh
              material={materials.lambert1}
              geometry={nodes.pCylinder8_lambert1_0.geometry}
            />
            <mesh
              material={materials.lambert1}
              geometry={nodes.pCylinder9_lambert1_0.geometry}
            />
            <mesh
              material={materials.lambert1}
              geometry={nodes.pCylinder5_lambert1_0.geometry}
            />
            {/* <mesh
              material={materials.lambert1}
              geometry={nodes.pCylinder14_lambert1_0.geometry}
            /> */}
          </group>
        </group>
      </Suspense>
    </mesh>
  )
}

useGLTF.preload('/three-fps/models/objects/fence01/scene.gltf')
